const $inject = ['$scope', '$routeParams', '$filter','dataService', 'settingsService'];

const lbaCompanyReferenceCodeSelectCtrl = function ($scope, $routeParams, $filter, dataService, settingsService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  const dataLookUpDataSource = dataService.spiltDataAt(vm.settings.dataSource, $routeParams);
  const companyReferences  = _.get(dataService.data.activeItem, dataLookUpDataSource);  

  vm.selectType = vm.settings.selectType || 'multi';
  vm.refreshCompanyReferences = refreshCompanyReferences;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshCompanyReferences(userSearch) {
    vm.companyReferences = $filter('filter')(companyReferences, userSearch, false);
  };

};

lbaCompanyReferenceCodeSelectCtrl.$inject = $inject;

export default lbaCompanyReferenceCodeSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceCodeSelect/lbaCompanyReferenceCodeSelectCtrl.js